<template>
    <div id="welcome" class="page">

      <div class="columns">
        <div class="column">

    <div class="stack-wrapper">
      <stack ref="stack" :pages="someList" :stackinit="stackinit"></stack>
    </div>
    
    <div class="controls">
      <button @click="prev" class="cbutton"><i class="chevron left"></i><span class="text-hidden">prev</span></button>
      <a href="/" class="button">Und los geht's</a>
      <button @click="next" class="cbutton"><i class="chevron right"></i><span class="text-hidden">next</span></button>
    </div>
    
    <div class="actions">
      <p></p>
    </div>
    <div class="legals"><p>kigebu ist eine Idee der <a href="http://dobetterhings.de" target="_blank">dobetterhings UG</a><br>Impressum • Datenschutz</p></div>

<!--
          <div id="slider">
            <div class="slide">
              <div id="welcomeLogo"><img src="../assets/img/kigebu-logo.png"></div>
            
            </div>
          </div>
-->

        </div>
      </div>        
    </div>
</template>
<script>
import stack from '../components/Stack'
export default {
  name: 'Home',
  components: {
    stack
  },
  methods: {
    prev () {
      this.$refs.stack.$emit('prev')
    },
    next () {
      this.$refs.stack.$emit('next')
    }
  },
  data () {
    return {
      someList: [],
      stackinit: {
        visible: 3
      }
    }
  },
  mounted () {
    let that = this
    setTimeout(function () {
      that.someList = [
        {
          html: '<div class="slide" id="about"><img src="/img/kigebu-logo.png"><h3>Dein Kind wurde zu einer Geburtstagsparty eingeladen</h3><p>Infos zur Party, Wunschzettel, Gästeliste, Fotos ...<br>kigebu ist die Online-Geburtstagbox.<br>&nbsp;</p></div>'
        },
/*
        {
          html: '<div class="slide"><img src="/img/kigebu-logo.png"></div>'
        },
        {
          html: '<div class="slide"><img src="/img/kigebu-logo.png"></div>'
        }
*/
      ]
    }, 1000)
  },
}
</script>
<style>
  #welcome.page {   padding: 0; }
  #welcomeLogoBox {
    display: grid;
    height: 100%;
    margin: 0;
    place-items: center center;	  
  }
  #welcomeLogo { }
  img { display: block; margin: 0 auto; max-width: 10em; }
  .column { padding: 1.93333333em;}
  h1 { text-align: center; }
  
  .slide { background: #fff; min-height: 65vh; padding: 1.43333333em; } 
  .slide#about { background: #fff7e9; }
  .stack-wrapper{
    margin: 0 auto;
    position: relative;
    z-index: 1000;
    width: 100%;
    height: 65vh;
    padding: 0;
    list-style: none;
    pointer-events: none;
  }
  .controls{
    position: relative;
    max-width: 260px;
    text-align: center;
    display:flex;/*Flex布局*/
    display: -webkit-flex; /* Safari */
    justify-content:space-around;
    margin: 0 auto;
    margin-top: 2.433333em
  }
  .controls .cbutton {
    border: none;
    outline: none !important;
    background: none;
    position: relative;
    display: inline-block;
    cursor: pointer;
    font-size: 16px;
    width: 50px;
    height: auto;
    z-index: 100;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    border-radius: 50%;
/*     background: #fff; */
  .controls .button { white-space: nowrap; }
  }
  .cbutton .next{
    display: inline-block;
    width: 10px;
    height:5px;
    background: rgb(129,212,125);
    line-height: 0;
    font-size:0;
    vertical-align: middle;
    -webkit-transform: rotate(45deg);
    left: -5px;
    top: 2px;
    position: relative;
  }
  .cbutton .next:after{
    content:'/';
    display:block;
    width: 20px;
    height:5px;
    background: rgb(129,212,125);
    -webkit-transform: rotate(-90deg) translateY(-50%) translateX(50%);
  }
  .cbutton .prev{
    display: inline-block;
    width: 20px;
    height:5px;
    background: rgb(230,104,104);
    line-height: 0;
    font-size:0;
    vertical-align: middle;
    -webkit-transform: rotate(45deg);
  }
  .cbutton .prev:after{
    content:'/';
    display:block;
    width: 20px;
    height:5px;
    background: rgb(230,104,104);
    -webkit-transform: rotate(-90deg);
  }
  .controls .text-hidden {
    position: absolute;
    overflow: hidden;
    width: 0;
    height: 0;
    color: transparent;
    display: block;
}  
</style>